import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {IdentityProviderType} from '@app/views/sso/identity-providers/identity-provider';

export class PassportLoginIDP {
    constructor(
        public districtId: number = null,
        public role: PASSPORT_LOGIN_IDP_ROLE = null,
        public firstFactor: PASSPORT_LOGIN_IDP_FACTOR = null,
        public secondFactor: PASSPORT_LOGIN_IDP_FACTOR = null,
        public validHours: number = null,
        public status: PASSPORT_LOGIN_IDP_STATUS = null,
        public grade: string = '',
    ) {
    }
}

export enum PASSPORT_LOGIN_IDP_FACTOR {
    FACE_ID = IdentityProviderType.AUTH_PROVIDER_FACEID_LOGIN,
    QRCODE = IdentityProviderType.AUTH_PROVIDER_QR_CODE,
    ACTIVE_DIRECTORY= IdentityProviderType.AUTH_PROVIDER_LDAP
}

export const PassportLoginIDPFactorFriendlyName = {
    [PASSPORT_LOGIN_IDP_FACTOR.FACE_ID]: 'Face ID',
    [PASSPORT_LOGIN_IDP_FACTOR.QRCODE]: 'QR Codes',
    [PASSPORT_LOGIN_IDP_FACTOR.ACTIVE_DIRECTORY]: 'Active Directory'
};

export enum PASSPORT_LOGIN_IDP_ROLE {
    STUDENT = 'Student',
    TEACHER = 'Teaching Staff'
}

export enum PASSPORT_LOGIN_IDP_STATUS {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}


export interface PassportLoginIDPMethodFormGroup {
    firstFactor: FormControl<PASSPORT_LOGIN_IDP_FACTOR | null>;
    secondFactor: FormControl<PASSPORT_LOGIN_IDP_FACTOR | null>;
    gracePeriod: FormControl<number | null>;
    grade?: FormControl<string | null>;
    districtId?: FormControl<string | null>;
    role?: FormControl<string | null>;
}

export interface PassportLoginIDPFormGroup {
    supportPassportLoginIDP: FormControl<boolean>;
    loginMethods: FormArray<FormGroup<PassportLoginIDPMethodFormGroup>>;
}

export function getPassportLoginIDPWithGradeAsNumber(passportLoginIDPs: PassportLoginIDP[]) {
    return passportLoginIDPs
        ?.map((item: PassportLoginIDP) =>
            ({
                ...item,
                validHours: Number(item.validHours),
                gracePeriod: Number(item['gracePeriod'])
            })
        );
}
